import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Game } from '../models/game';
import { ConfigService } from '../services/config.service';
import { GameBaseApi } from './game-base-api';
import { RugbyGameTeamStatistic } from '../models/rugby-game-team-statistic';
import { RugbyGameStatistic } from '../models/rugby-game-statistic';
import { RugbyGameLog } from '../models/rugby-game-log';
import { RugbyFoulType } from '../models/rugby-foul-type';

@Injectable({providedIn: 'root'})
export class RugbyGameApi extends GameBaseApi {
  constructor(
    protected httpClient: HttpClient,
    protected configService: ConfigService
  ) {
    super(httpClient, configService);
  }

  async getById(gameId: number): Promise<Game> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_rugby_game/${gameId}/`).pipe(
      map(result => Game.toFront(result))
    ).toPromise();
  }

  async getTeamStatistic(gameId: number): Promise<RugbyGameTeamStatistic> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_rugby_game/${gameId}/team_statistic/`).pipe(
      map(result => RugbyGameTeamStatistic.toFront(result))
    ).toPromise();
  }

  async getUserStatistic(gameId: number): Promise<RugbyGameStatistic[]> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_rugby_game/${gameId}/user_statistic/`).pipe(
      map(result => RugbyGameStatistic.toFront(result))
    ).toPromise();
  }

  async getLogs(gameId: number): Promise<RugbyGameLog[]> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_rugby_game/${gameId}/logs/`).pipe(
      map(result => RugbyGameLog.toFront(result))
    ).toPromise();
  }

  async getFoulTypes(): Promise<RugbyFoulType> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_rugby_game/foul_types/`).pipe(
      map(result => RugbyFoulType.toFront(result))
    ).toPromise();
  }

  async downloadProtocol(gameId: number): Promise<any> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_rugby_game/${gameId}/game_protocol/`, {
      params: new HttpParams().set('file_type', 'pdf'),
      responseType: 'blob'
    }).toPromise();
  }
}
